// Formats number with whitespace as a thousands separator
export const formatReviewCount = (count: number) => {
  const countString = count.toString();
  if (countString.length <= 3) return count;
  return countString.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ');
};
